import { Component, OnInit } from '@angular/core';
import { IstanzaService } from '../../services/istanza.service';
import { SubscriptionManager } from '../../shared/subscription-manager/subscription-manager.class';
import { ActivatedRoute, Router } from '@angular/router';
import { IstanzaDTO } from '../../models/istanza';
import { FormBuilder, Validators } from '@angular/forms';
import { RatingService } from '../../services/rating.service';
import { AlertService } from '../../shared/alert/alert.service';
import { AmministrazioneService } from '../../services/amministrazione.service';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-richiesta-inviata',
  templateUrl: './richiesta-inviata.component.html',
  styleUrls: ['./richiesta-inviata.component.scss']
})
export class RichiestaInviataComponent extends SubscriptionManager implements OnInit {
  id: string;
  loading = false;
  istanzaCorrente?: IstanzaDTO;
  ratingForm = this._fb.group({
    valutazione: [this._fb.control<number | null>(null), Validators.required],
    primaRisposta: [this._fb.control<number | null>(null)],
    secondaRisposta: [this._fb.control<number | null>(null)],
    pnServizio: this._fb.group({
      id: ['', Validators.required]
    }),
    note: [''],
  })
  feedbackInviato = false;
  selectedRating = 0;
  questionText = '';
  choices: string[] = [];
  inTextAreaPhase = false; // Aggiunto

  constructor(private istanzaService: IstanzaService, protected configurazioneGeneraleService: ConfigurazioneGeneraleService, private router: Router,private activatedRoute: ActivatedRoute, private alertService: AlertService, private ammService: AmministrazioneService, private _fb: FormBuilder, private ratingService: RatingService) {
    super();
    this.id = this.activatedRoute.snapshot.params.idIstanza;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.subs.sink = this.istanzaService.getDatiIstanza(this.id).subscribe({
      next: (res) => {
        this.istanzaCorrente = res;
      }
    })
    this.ammService.getIdByNmServizio("Tributi").subscribe({
      next: (res) => {
        this.ratingForm.patchValue({
          pnServizio: {
            id: res,
          }
        })
      }
    })
  }

  downloadPdf():void{
    let titoloAllegato = '';
    if (this.istanzaCorrente?.istanza.servizio.cdServizio !== "IMU"){
      titoloAllegato = 'Ist_' + this.id + '.pdf';
      } else {
      titoloAllegato ='IMU_' + this.id + '.pdf';
    }
    this.istanzaCorrente?.documentiOperatore?.forEach(all => {
      if (all.allegato.titolo === titoloAllegato) {
        const base64pdf = String(all.allegato.contenuto);
        const source = 'data:application/pdf;base64,' + `${<string>base64pdf}`;
        const link = document.createElement('a');
        link.href = source;
        link.download = `${all.allegato.titolo}`;
        link.click();
      }
    });
  }

  resetSelection(): void {
    this.ratingService.resetArray(); // Resetta l'array delle stelle tramite il servizio
    this.ratingForm.get('valutazione')?.setValue(null)
    this.selectedRating = 0;
    this.questionText = '';
    this.choices = [];
  }

  goToDatiIstanza():void{
    this.router.navigate(["Servizi/DettaglioIstanza/" + this.id])
  }

  handleChoiceSelected(selectedIndex: number): void {
    if (this.selectedRating < 4) {
      this.ratingForm.patchValue({
        primaRisposta: null,
        secondaRisposta: selectedIndex,
      });
    } else {
      this.ratingForm.patchValue({
        primaRisposta: selectedIndex,
        secondaRisposta: null,
      })
    }
  }

  submitQuestion(): void {
    this.loading = true;
    this.subs.sink = this.ratingService.salvaFeedback(this.ratingForm.value).subscribe({
      error: (err) => {
        this.feedbackInviato = false;
        this.loading = false;
        this.alertService.creaAlert(err.error.messaggio, 'danger', "sticky", 5000, true);
      },
      complete: () => {
        this.feedbackInviato = true;
        this.loading = false;
        this.alertService.creaAlert('Feedback inviato con successo.', "success", "sticky", 5000, true);
      }
    });
  }

  showTextArea(): void {
    this.inTextAreaPhase = true; // Abilita la fase del campo di testo libero
  }

  backToChoices(): void {
    if (this.inTextAreaPhase) {
      this.inTextAreaPhase = false;
    }
  }

  onRatingSelected(rating: number): void {
    this.selectedRating = rating;
    this.ratingForm.get('valutazione')?.setValue(rating)
    if (this.selectedRating <= 3) {
      this.questionText = "Dove hai incontrato le maggiori difficoltà?";
      this.choices = ["A volte le indicazioni non erano chiare", "A volte le indicazioni non erano complete", "A volte non capivo se stavo procedendo correttamente", "Ho avuto problemi tecnici", "Altro"];
    } else {
      this.questionText = "Quali sono stati gli aspetti che hai preferito?";
      this.choices = ["Le indicazioni erano chiare", "Le indicazioni erano complete", "Capivo sempre che stavo procedendo correttamente", "Non ho avuto problemi tecnici", "Altro"];
    }
    this.inTextAreaPhase = false;
  }

  goToServizi():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkServizi;
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }
}
